// extracted by mini-css-extract-plugin
module.exports = {"Container":"DropzoneContent_Container__2X0Am","Image":"DropzoneContent_Image__9gP-8"};